import { DateTime } from 'luxon'
import { makeAutoObservable } from 'mobx'
import apiClient from 'src/utils/apiClient'
import {
  SendInquiryParams,
  UpdatePayerInfoParams,
  RequestMoveOutParams as _RequestMoveOutParams,
} from 'src/utils/apiClient/users'

type RequestMoveOutParams = Omit<_RequestMoveOutParams, 'moveOutOn'> & {
  moveOutOn: DateTime
}

export default class UserStore {
  // Constructor ------------

  constructor() {
    makeAutoObservable(this)
  }

  // Actions ---------------

  requestMoveOut = async (params: RequestMoveOutParams) => {
    await apiClient.users.requestMoveOut({
      ...params,
      moveOutOn: params.moveOutOn.toFormat('yyyy-MM-dd'),
    })
  }

  sendInquiry = async (params: SendInquiryParams) => {
    await apiClient.users.sendInquiry(params)
  }

  updatePayerInfo = async (params: UpdatePayerInfoParams) => {
    await apiClient.users.updatePayerInfo(params)
  }
}
